import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-childrenStatic",
  "use": "icon-childrenStatic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-childrenStatic\"><path d=\"M513.365333 521.216h437.248c0-252.188444-193.820444-457.443556-437.248-469.788444v469.788444zM460.231111 595.171556a23.324444 23.324444 0 0 1-22.983111-23.495112V78.904889C193.820444 91.249778 0 296.220444 0 548.124444c0 259.811556 206.051556 470.414222 460.231111 470.414223 238.705778 0 434.915556-185.685333 458.012445-423.367111h-457.955556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/childrenStatic.svg
// module id = qAzw
// module chunks = 78